// DeleteHandbookModal.tsx
import { Modal, Button, Typography } from 'antd'
import { Stack } from '@sureco/design-system'
import React from 'react'
const { Title, Text } = Typography

export default function DeleteHandbookModal({
  open,
  handbook,
  onDelete,
  onCancel,
  isDeleting,
}: {
  open: boolean
  handbook: { fileName: string } | null
  onDelete: () => void
  onCancel: () => void
  isDeleting: boolean
}) {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={500}
      style={{ borderRadius: 16 }}
    >
      <Stack space={24} align="center">
        {/* Title */}
        <Title level={2} style={{ marginBottom: 0, textAlign: 'center' }}>
          Delete this file?
        </Title>

        {/* File preview box */}
        {handbook && (
          <div
            style={{
              padding: '16px 20px',
              borderRadius: 12,
              background: '#F5FAFB',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              border: '1px solid #E8F3F5',
            }}
          >
            <span
              style={{
                fontSize: 20,
                color: '#00A2AE',
                display: 'inline-flex',
              }}
            >
              📄
            </span>
            <Text style={{ color: '#00A2AE', fontSize: 16 }}>
              {handbook.fileName}
            </Text>
          </div>
        )}

        {/* Delete Button */}
        <Button
          type="primary"
          block
          size="large"
          style={{
            height: 50,
            fontSize: 18,
            background: '#00A2AE',
            borderRadius: 12,
          }}
          onClick={onDelete}
          loading={isDeleting}
        >
          Delete File
        </Button>

        {/* Cancel Link */}
        <Button
          type="link"
          onClick={onCancel}
          style={{
            color: '#888',
            fontSize: 16,
            marginTop: 4,
          }}
        >
          Cancel
        </Button>
      </Stack>
    </Modal>
  )
}
